import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import ProductOverview from '../components/sections/ProductOverview';
import BrandPillars from '../components/sections/BrandPillars';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import CTASection from '../components/sections/CTASection';
import StatsSection from '../components/sections/StatsSection';

const Home = () => {
  return (
    <div>
      {/* Hero Section - Off-White Background */}
      <div className="bg-automats-off-white">
        <HeroSection />
      </div>
      
      {/* Stats Section - White Background */}
      <div className="bg-white">
        <StatsSection />
      </div>
      
      {/* Product Overview - Off-White Background */}
      <div className="bg-automats-off-white">
        <ProductOverview />
      </div>
      
      {/* Brand Pillars - White Background */}
      <div className="bg-white">
        <BrandPillars />
      </div>
      
      {/* Testimonials - Off-White Background */}
      <div className="bg-automats-off-white">
        <TestimonialsSection />
      </div>
      
      {/* CTA Section - White Background */}
      <div className="bg-white">
        <CTASection />
      </div>
    </div>
  );
};

export default Home;